export default __webpack_public_path__ + "static/area_5-e1ac9382450e395b9e784dd996b28f04.jpg";